import { FormObjType } from "DataTypes/Form";

export const AddEditForm: FormObjType[] = [
  {
    id: "productName",
    label: "Product Name",
    placeholder: "Enter Product Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeholder: "Select Start Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
    notValidateMinMax: true
  },
  {
    id: "endDate",
    label: "Stop Date",
    placeholder: "Select End Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: false,
    enableFormLoad: true,
    notValidateMinMax: true
  },
  {
    id: "doseQuantity",
    label: "Dose Quantity",
    placeholder: "Enter Dose Quantity",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "doseUnits",
    label: "Dose Units",
    placeholder: "Enter Dose Units",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "frequencyPeriod",
    label: "Frequency",
    placeholder: "Enter Frequency",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "frequencyUnit",
    label: "Frequency Unit",
    placeholder: "Enter Frequency Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "routeName",
    label: "Route Name",
    placeholder: "Enter Route Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
]